import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/basic/typography";
import Radio from "components/basic/radio";
import { Language, LANGUAGE_NAMES, LANGUAGES } from "locales/constants";

interface LanguagePickerProps {
  selected: string | null;
  disabled?: boolean;
  onSelect: (language: Language | null) => void;
}

/** The language the portal opens in; clients can still switch. */
const LanguagePicker: React.FC<LanguagePickerProps> = ({
  selected,
  disabled,
  onSelect,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("profile");

  return (
    <div style={{ marginTop: theme.spacing(4) }}>
      <Typography variant="body1">{t("private_link.language")}</Typography>
      <Typography
        variant="body2"
        style={{
          color: theme.palette.grey[700],
          marginTop: theme.spacing(0.5),
        }}
      >
        {t("private_link.language_hint")}
      </Typography>

      <div style={{ marginTop: theme.spacing(1) }}>
        <Radio
          isSelected={!selected}
          disabled={disabled}
          onChange={() => onSelect(null)}
          label={t("private_link.language_browser")}
        />
        {LANGUAGES.map((language) => (
          <Radio
            key={language}
            isSelected={language === selected}
            disabled={disabled}
            onChange={() => onSelect(language)}
            label={LANGUAGE_NAMES[language]}
          />
        ))}
      </div>
    </div>
  );
};

export default LanguagePicker;
